export default __webpack_public_path__ + "static/media/radius_sun.9f56ec64.png";